document.addEventListener("DOMContentLoaded", () => {
  const carousels = document.querySelectorAll('[data-js-target="carousel"]');

  window.emblaCarouselsMap = new Map();

  carousels.forEach((carousel) => {
    const carouselContainer = carousel.querySelector(
      '[data-js-target="carousel__container"]'
    );
    const carouselItems = carousel.querySelectorAll("[data-js-carousel-item]");

    let embla = null;

    const carouselMedia = carouselContainer.dataset.jsCarouselMedia;
    const carouselAlign = carouselContainer.dataset.jsCarouselAlign;
    const carouselDragFree = carouselContainer.dataset.jsCarouselDragFree;
    const carouselLoop = carouselContainer.dataset.jsCarouselLoop;

    const carouselName = carouselContainer.dataset.jsCarouselName;

    const carouselAutoplay = carouselContainer.dataset.jsCarouselAutoplay;
    const carouselAutoplayDelay =
      carouselContainer.dataset.jsCarouselAutoplayDelay;

    // We put the event listeners on the carousel items here
    // Because, if we put it in the init function, we'll have issues with memory leaks
    carouselItems.forEach((item) => {
      item.addEventListener("click", () => {
        if (!embla) return;

        const itemId = parseInt(item.dataset.jsCarouselItem);

        if (isNaN(itemId) || itemId < 0) return;

        embla.scrollTo(itemId);

        carouselItems.forEach((otherItem) => {
          const otherItemId = parseInt(otherItem.dataset.jsCarouselItem);

          if (isNaN(otherItemId) || otherItemId < 0) return;

          const shouldBeActive = otherItem === item || otherItemId === itemId;
          otherItem.classList.toggle("carousel__active", shouldBeActive);
        });
      });
    });

    function updateActiveItem() {
      const selectedIndex = embla.selectedScrollSnap();

      carouselItems.forEach((item) => {
        const itemId = parseInt(item.dataset.jsCarouselItem);

        if (isNaN(itemId) || itemId < 0) return;

        item.classList.toggle("carousel__active", itemId === selectedIndex);
      });
    }

    function initEmbla() {
      if (embla !== null) return;

      const plugins = [];

      plugins.push(window.EmblaCarouselWheelGestures());

      if (carouselAutoplay) {
        plugins.push(
          window.EmblaCarouselAutoplay({
            delay: carouselAutoplayDelay ?? 5_000,
          })
        );
      }

      embla = EmblaCarousel(
        carouselContainer,
        {
          loop: carouselLoop === "true" ? true : false,
          align: carouselAlign ?? "start",
          containScroll: "trimSnaps",
          dragFree: carouselDragFree === "false" ? false : true,
        },
        plugins
      );

      if (carouselName) {
        window.emblaCarouselsMap.set(carouselName, embla);
      }

      embla.on("select", updateActiveItem);
      updateActiveItem();

      const prevButton = carousel.querySelector('[data-js-action="prev"]');
      const nextButton = carousel.querySelector('[data-js-action="next"]');

      if (!prevButton || !nextButton) return;

      prevButton.addEventListener("click", () => embla.scrollPrev());
      nextButton.addEventListener("click", () => embla.scrollNext());

      function updateArrows() {
        prevButton.disabled = !embla.canScrollPrev();
        nextButton.disabled = !embla.canScrollNext();
      }

      embla.on("select", updateArrows);

      updateArrows();
    }

    carousel.addEventListener("carousel:snapTo", (e) => {
      const itemId = e.detail?.id;

      if (embla && !isNaN(itemId) && itemId >= 0) {
        embla.scrollTo(itemId);
      }
    });

    function destroyEmbla() {
      if (embla === null) return;

      embla.destroy();
      embla = null;
    }

    if (!carouselMedia) {
      initEmbla();
    } else {
      const mediaQuery = window.matchMedia(carouselMedia);

      function handleMediaChange(e) {
        if (e.matches) {
          initEmbla();
        } else {
          destroyEmbla();
        }
      }

      handleMediaChange(mediaQuery);
      mediaQuery.addEventListener("change", handleMediaChange);
    }
  });
});
